export default "__VITE_ASSET__1f27f612__"